import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import './AmountFilter.scss';

export default class AmountFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <input
                className="filter-input amount-filter"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
                type="text"
            />
        );
    }
}
